import { render } from "./WebhookAddEditDialog.vue?vue&type=template&id=789df387&scoped=true"
import script from "./WebhookAddEditDialog.vue?vue&type=script&lang=js"
export * from "./WebhookAddEditDialog.vue?vue&type=script&lang=js"

import "./WebhookAddEditDialog.vue?vue&type=style&index=0&id=789df387&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789df387"]])

export default __exports__